import { Link } from '@mui/material';
import useStyles from './useStyles';
import { useNavigate, useSearchParams } from 'react-router-dom';
import translate from '../../../i18n/translate';
import OrganizerRequestDataGrid from '../OrganizerRequestDataGrid';

const OrganizerRequestListScreen = () => {
  const classes = useStyles();
  const navigate = useNavigate()

  const [searchParams] = useSearchParams();

  const organizerId = searchParams.get("organizerId")

  return(
      <div className={classes.Wrapper}>
        <div className={classes.StatusesList}>
          <Link 
            color="#fc7f03" 
            className={classes.ToMain} 
            mr={10} 
            ml="10px" 
            onClick={() => navigate("/")}
          >
            {translate('commonBackToTheMainPage')}
          </Link>
          <div/>
        </div>
        <OrganizerRequestDataGrid organizerId={organizerId ? Number(organizerId) : undefined} />
      </div>
  )
}

export default OrganizerRequestListScreen;